import { Pipe, PipeTransform } from '@angular/core';
import { IConversationHeaderComponentData } from '../conversation-header.component';

@Pipe({
  name: 'title',
  standalone: true,
})
export class TitlePipe implements PipeTransform {
  static baseTitle: string = 'Conversation';

  transform(data: IConversationHeaderComponentData): string {
    const { inferredContactSubtype, inferredContactType } = data.contactDetails?.data ?? {};
    let resultTitle = '';

    if (data.conversationDetails.data?.callDirection.toLowerCase() === 'outbound') {
      resultTitle = 'Outbound ';
    }

    if (inferredContactType?.toLowerCase() === 'prospect') {
      resultTitle += 'Prospect';
    } else if (inferredContactType?.toLowerCase() === 'non-prospect' && inferredContactSubtype?.length) {
      resultTitle += inferredContactSubtype;
    }

    return `${resultTitle} ${TitlePipe.baseTitle}`;
  }
}
